<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col class="d-flex justify-center align-center">
        <ag-grid-vue class="ag-theme-balham" :style="{ width: '90%', height: '25vh' }" :localeText="localeTextSpanish"
          :columnDefs="columnDefs" :rowData="rowData" ref="agGrid" @cell-clicked="onCellClicked">
        </ag-grid-vue>
      </v-col>
    </v-row>
    <!-- modal - 1 polidocente -->
    <ComunDialogComp v-model="mostrarModal" persistent max-width="800" :title="title" @close-modal="closeModal">
      <template v-slot:body>
        <v-form>
          <v-card flat>
            <v-container fluid>
              <v-card-title>{{ title2 }}</v-card-title>
              <v-row>
                <v-col cols="4" class="mt-1 d-flex gap-5px">
                  <AutocompleteComp dense textLabel="Grado" @input="getAllSeccionesGrados(id_grado)"
                    :items="gradosAdmin" item-value="id" item-text="desc_grado" v-model="id_grado"
                    style="max-width: 200px"></AutocompleteComp>
                </v-col>

                <v-col cols="4" class="mt-1 d-flex gap-10px">
                  <AutocompleteComp dense @change="seleccionarSeccion(id_seccion)" textLabel="Sección"
                    :items="SeccionGrado" item-value="id" item-text="nombre_seccion" v-model="id_seccion"
                    style="max-width: 200px"></AutocompleteComp>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="turno" label="Turno:" filled disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select dense label="Cursos" :items="cursoPolidocente" item-value="id_cursos" item-text="desc_curso"
                    v-model="cursosSeleccionados" attach chips multiple hide-details return-object disabled>
                    <template v-slot:selection="{ item, index }">
                      <v-chip :key="index" close @click:close="remove(item)" class="chip-custom">
                        {{ item.desc_curso }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeModal">Cerrar</v-btn>
              <v-btn color="blue darken-1" text @click="saveCursos">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </ComunDialogComp>
    <!--modal del docente de area-->
    <ComunDialogComp v-model="mostrarModal2" persistent max-width="800" :title="title" @close-modal="closeModal">
      <template v-slot:body>
        <v-form>
          <v-card flat>
            <v-container fluid>
              <v-card-title>{{ title2 }}</v-card-title>
              <v-row>
                <v-col cols="4" class="mt-1 d-flex gap-5px">
                  <v-select dense label="Grado" @change="getAllSeccionesGradosAreas(id_grado)" :items="gradosAdmin"
                    item-value="id" item-text="desc_grado" v-model="id_grado" multiple
                    style="max-width: 150px"></v-select>
                </v-col>

                <v-col cols="8" class="mt-1 d-flex gap-10px">
                  <v-select dense @input="cursoDocenteArea(id_grado)" label="Sección" :items="SeccionGradoAreas"
                    :item-text="formatSeccionGrado" item-value="id" multiple v-model="id_seccion" 
                    style="max-width: 400px"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select dense label="Cursos" :items="cursoDocente" item-value="id_curso" item-text="curso" 
                    v-model="curso" attach chips multiple hide-details disabled >
                    <template v-slot:selection="{ item, index }">
                      <v-chip :key="index" close @click:close="remove(item)" class="chip-custom">
                        {{ item.curso }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeModal">Cerrar</v-btn>
              <v-btn color="blue darken-1" text @click="saveCursos">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </ComunDialogComp>
    <!--modal tutor-->
    <ComunDialogComp v-model="mostrarModal3" persistent max-width="800" :title="title" @close-modal="closeModal">
      <template v-slot:body>
        <v-form>
          <v-card flat>
            <v-container fluid>
              <v-card-title>{{ title2 }}</v-card-title>
              <v-row>
                <v-col cols="4" class="mt-1 d-flex gap-5px">
                  <v-select dense label="Grado" @change="getAllSeccionesGradosAreas(id_grado)"  :items="gradosAdmin"
                    item-value="id" item-text="desc_grado" v-model="id_grado" multiple
                    style="max-width: 150px"></v-select>
                </v-col>

                <v-col cols="8" class="mt-1 d-flex gap-10px">
                  <v-select dense @change="cursoDocenteArea(id_grado)" label="Sección" :items="SeccionGradoAreas"
                    :item-text="formatSeccionGrado" item-value="id" multiple v-model="id_seccion" 
                    style="max-width: 400px"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select dense label="Cursos" :items="cursoDocente" item-value="id_curso" item-text="curso" 
                    v-model="curso" attach chips multiple hide-details>
                    <template v-slot:selection="{ item, index }">
                      <v-chip :key="index" close @click:close="remove(item)" class="chip-custom" disabled >
                        {{ item.curso }}
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeModal">Cerrar</v-btn>
              <v-btn color="blue darken-1" text @click="saveCursos">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </ComunDialogComp>
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import { AgGridVue } from "ag-grid-vue";
import { mapMutations } from "vuex";
import ComunDialogComp from "../../../../../src/components/ComponentsEst/ComunDialogComp.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";

export default {
  name: "docente",
  components: {
    AgGridVue,
    ComunDialogComp,
    AutocompleteComp,
  },
  props: {
    cursosActualizados: {
      type: Array,
      default: () => [],
    },
    id_nivel: {
      type: [String, Number],
      required: false,
    },
    id_nivel_act: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      localeTextSpanish: {
        noRowsToShow: "No hay datos para mostrar",
      },
      gridApi: null,
      gridColumnApi: null,
      columnDefs: [
        {
          headerName: "Docente",
          field: "nombre_apellido",
          width: 270,
        },
        {
          headerName: "Tipo de docente",
          field: "tipo_docente",
          width: 250,
        },
        { headerName: "Grado", field: "desc_grado", width: 250 },
        {
          headerName: "Sección",
          field: "nombre_seccion",
          width: 250,
        },
        {
          headerName: "Editar",
          cellRenderer: this.iconCellRenderer,
          width: 250,
        },
      ],
      //variables para el modal
      mostrarModal: false,
      rowData: [],
      nombre_apellido: "",
      tipo_docente: "",
      nivel: "",
      desc_nivel: "",
      id_grado: [],
      id_grado_curso: [],
      id_seccion: [],
      desc_grado: [],
      id_curso: [],
      idCursoFinal: [],
      areaFinal: [],
      actualizarCurso: [],
      SeccionGrado: [],
      SeccionGradoAreas: [],
      seccion: "",
      turno: "",
      id_turno: null,
      curso: [],
      cursoPolidocente: [],
      gradosAdmin: [],
      cursoDocente: [],
      id_area_admin: [],
      id_area_docente: [],
      id_area_polidocente: [],
      id_persona: "",
      id_personales: "",
      id_tipo_docente: "",
      //variables modal2
      mostrarModal2: false,
      mostrarModal3: false,
      horariosDocentes: [],
      seccionAdmin: [],
      nombre_seccion: [],
      turnoSeleccionado: [],
      cursosSeleccionados: [],
    };
  },
  mounted() {
    if (this.checkIdNivel()) {
      this.getNivel();
      this.getGradosAdmin();
      this.fetchAndCombineData();
      this.getSeccionAdmin();
    }
  },
  watch: {
    cursosActualizados: {
      handler() {
        if (this.checkIdNivel()) {
          this.handleCursosActualizados();

        }
      },
      deep: true,
      immediate: true,
    }
  },
  computed: {
    title() {
      return `Asignar sección/curso al docente: ${this.nombre_apellido}.`;
    },
    title2() {
      return `Tipo de docente: ${this.tipo_docente}.`;
    },
  },
  methods: {
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    checkIdNivel() {
      if (!this.id_nivel || this.id_nivel === '') {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe seleccionar un nivel`,
          tiempo: null
        });
        return false;
      } else {
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Nivel seleccionado satisfactoriamente`,
          tiempo: null
        });
        return true;
      }
    },

    iconCellRenderer(params) {
      const isTrue = params.data.registro;
      const iconElement = document.createElement("i");
      iconElement.className = "fa fa-solid fa-pen";
      if (isTrue) {
        iconElement.classList.add("icon-blue");
      }
      return iconElement;
    },

    handleCursosActualizados() {
      this.getGradosAdmin();
      this.getSeccionAdmin();
      this.fetchAndCombineData();
    },

    // metodo para traer las grados por nivel -- aca debo agregar el id_area --
    async getGradosAdmin() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_nivel: this.id_nivel,
      };

      try {
        let response = await axios.post(
          "/horario/horarioDocente/grados/",
          params
        );
        this.gradosAdmin = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // metodo que trae la seccion por niveles donde se le pasa id_colegio, id_nivel, id_ano_lectivo
    async getSeccionAdmin() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_nivel: this.id_nivel,
      };

      try {
        let response = await axios.post(
          "/horario/horarioDocente/seccion/",
          params
        );
        this.seccionAdmin = response.data;
    
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    // esta tabla trae informacion de las tablas
    async fetchAndCombineData() {
      try {
        // Realiza ambas peticiones en paralelo para la tabla principal
        const [responseDocentes, responseHorarios] = await Promise.all([
          axios.get(
            `/horario/horarioClase/${this.id_nivel}/${this.id_colegio}/`
          ),
          axios.get(`/horario/horarioDocente/${this.id_nivel}`),
        ]);
        this.setEnviarMens({
          messageT: "S",
          tipo: responseDocentes.data.messageT,
          mensaje: responseDocentes.data.message,
          tiempo: null,
        });
        // Procesa los horarios para obtener desc_grados
        this.horariosDocentes = responseHorarios.data.map((horario) => {
          horario.desc_grados = horario.id_grado.map((id) => {
            const grado = this.gradosAdmin.find((g) => g.id == id);
            return grado ? grado.desc_grado : "Descripción no encontrada";
          });

          horario.desc_seccion = horario.id_seccion.map((seccion) => {
            const secc = this.seccionAdmin.find((s) => s.id == seccion);
            return secc ? secc.nombre_seccion : "Sección no encontrada";
          });
          return horario;
        });
        
        const descGradoMap = {};
        const seccionMap = {};
        this.horariosDocentes.forEach((docente) => {
          if (docente.desc_grados.length > 0) {
            descGradoMap[docente.id_personales] =
              docente.desc_grados.join(", ");
          }
          if (docente.desc_seccion.length > 0) {
            seccionMap[docente.id_personales] = docente.desc_seccion.join(", ");
          }
        });
        

        this.rowData = responseDocentes.data.data.map((item) => {
          return {
            nombre_apellido: `${item.nombre_persona} ${item.ape1_persona} ${item.ape2_persona}`,
            tipo_docente: item.desc_tipo_docente,
            nivel: item.nivel,
            grado: item.grado,
            seccion: item.seccion,
            turno: item.turno,
            id_area_docente: item.id_areas_docente,
            id_personales: item.id_personales,
            id_persona: item.id_persona,
            id_tipo_docente: item.tipo_docente,
            nombre_seccion:
              seccionMap[item.id_persona] || "Sección no actualizada",
            desc_grado: descGradoMap[item.id_persona] || "Grado no actualizado",
          };
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    remove(item) {
      // Verifica si el curso existe en this.curso
      if (this.curso && this.curso.includes(item.id)) {
        const index = this.curso.indexOf(item.id);

        if (index >= 0) {
          // Elimina el curso del array this.curso
          this.curso.splice(index, 1);

          // Elimina el id_area_admin en el mismo índice
          if (this.id_area_admin && this.id_area_admin.length > index) {
            this.id_area_admin.splice(index, 1);
          }
        }
      }

    },


    closeModal() {
      this.mostrarModal = false;
      this.mostrarModal2 = false;
      this.mostrarModal3 = false;
      this.resetForm();

    },

    resetForm() {
      this.id_grado = null;
      this.id_seccion = null;
      this.turno = "";
      this.cursosSeleccionados = [];
      this.curso = [];
      this.id_area_admin = [];
      this.idCursoFinal = [];
      this.areaFinal = [];
      //this.getSeccionAdmin();
    },

    abrirModalSegunTipoDocente(tipo_docente) {
      if (tipo_docente == "Area") {
        this.mostrarModal2 = true;
      } else if (tipo_docente == "Polidocente") {
        this.mostrarModal = true;
      } else {
        this.mostrarModal3 = true;
      }
    },
    onCellClicked(event) {
  
      if (event.event.target.classList.contains("fa-pen")) {
        if (event.data.desc_grado === "Grado no actualizado") {
          this.crearNuevoRegistro(event);
        } else {
          this.editarRegistroExistente(event);
        }
      }
    },

    async getNivel() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
      };
      try {
        let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
          filter: params,
        });

        this.listNivel = response.data;

        const nivel = this.listNivel.find((n) => n.id === this.id_nivel);
        if (nivel) {
          this.desc_nivel = nivel.desc_nivel;
        } 
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getTurno(id_turno) {
  
      try {
        let response = await axios.get(`/mantenimiento/turnos/${id_turno}`);
        this.turnoSeleccionado = response.data;
        this.turno = this.turnoSeleccionado.desc_turno;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    //*******desde aca comenzamo con los modales *********
    //**para crear un nuevo registro en polidocente.**
    crearNuevoRegistro(event) {
   
      this.id_persona = event.data.id_personales;
      this.id_personales = event.data.id_persona;
      this.nombre_apellido = event.data.nombre_apellido;
      this.tipo_docente = event.data.tipo_docente;
      this.id_tipo_docente = event.data.id_tipo_docente || null;
      this.id_turno = event.data.id_turno;
      this.id_grado_docente = event.data.id_grado_docente;
      
      if (this.id_tipo_docente == 2) {
        this.id_area_docente = event.data.id_area_docente;

      } else {
        this.id_area_docente = event.data.id_area_docente;
  
      }

      this.abrirModalSegunTipoDocente(event.data.tipo_docente);
    },

    //****metodo de query para secciones del polidocente */

    //// metodo que busca las secciones por el grado seleccionado
    async getAllSeccionesGrados(id_grado) {
      this.id_grado = id_grado;
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_grado,
      };
 

      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado/",
          params
        );
        this.SeccionGrado = response.data;

        this.cursoDocentePolidocente(id_grado)

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    seleccionarSeccion(id) {
      const seccion = this.SeccionGrado.find((item) => item.id === id);
      if (seccion) {
        this.id_grado = seccion.id_grado;
       // this.cursoDocentePolidocente(this.id_grado);
        this.turno = seccion.ck1_mant_turno.desc_turno;
        this.id_turno = seccion.id_turno;
      } else {
        this.turno = "";
      }
    },

    associateGradosWithSecciones() {
    
      // Filtrar los grados que corresponden a los IDs de this.id_grado
      const filtrados = this.gradosAdmin.filter((curso) =>
        this.id_grado.includes(curso.id)
      );

      // Mapear para obtener id_grado_curso basado en los grados filtrados
      this.id_grado_curso = filtrados.map((curso) => curso.id_grados);

      // Asociar grados con secciones y agregar desc_grado al array this.SeccionGrado
      this.SeccionGrado = this.SeccionGrado.map((seccion) => {
        let grado = this.gradosAdmin.find(
          (grado) => grado.id === seccion.id_grado
        );

        if (grado) {
          seccion.desc_grado = grado.desc_grado;
        } else {
          seccion.desc_grado = "Grado desconocido";
        }
        return seccion;
      });
    },

    // en el caso de polidocente necesito renderizar todos los cursos
    async cursoDocentePolidocente(id_grado) {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_grado: id_grado,
        id_nivel: this.id_nivel,
        id : this.id_area_docente
      };
  
      try {
        let response = await axios.post(
          "/horario/horarioDocente/polidocente/cursos/",
          params
        );
  
       
        this.cursoPolidocente = response.data;
        this.cursosSeleccionados = response.data;

      

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },


    // metodo para editar un registro en polidocente

    editarRegistroExistente(event) {

      const horarioDocente = this.horariosDocentes.find(
        horario => horario.id_persona === event.data.id_personales
      );


      if (horarioDocente) {
        this.nombre_apellido = event.data.nombre_apellido;
        this.tipo_docente = event.data.tipo_docente;
        this.id_tipo_docente = event.data.id_tipo_docente;
        this.id_grado = horarioDocente.id_grado;
        this.id_seccion = horarioDocente.id_seccion;
        this.id_persona = event.data.id_personales;
        this.id_personales = event.data.id_persona;
        this.id_turno = horarioDocente.id_turno;
        // this.seleccionarSeccion(this.id_seccion);


        if (this.id_tipo_docente == 2) {
          this.id_grado = horarioDocente.id_grado[0];
          this.id_seccion = horarioDocente.id_seccion[0];
          this.cursosSeleccionados= horarioDocente.id_curso;
          this.id_area_polidocente = horarioDocente.area;
         // this.actualizarCurso = this.cursosSeleccionados;
          this.id_area_docente = horarioDocente.area;
          this.id_cursos = horarioDocente.id_curso;
          this.getAllSeccionesGrados(this.id_grado);
          this.cursoDocentePolidocente(this.id_grado);
          this.getTurno(this.id_turno);
          
        } else {
          this.id_area_docente = event.data.id_area_docente;
          this.id_curso = horarioDocente.id_curso;
          this.area = horarioDocente.area;
          this.getAllSeccionesGradosAreas(this.id_grado);
          this.cursoDocenteArea(this.id_grado);
        }
       

        this.abrirModalSegunTipoDocente(event.data.tipo_docente);
      } else {
        this.setEnviarMens({ tipo: "E", mensaje: "No se encontró un horario docente correspondiente", tiempo: null });
      }
    },

    //metodos para docentes de area .
    async getAllSeccionesGradosAreas(id_grado) {
        if (!id_grado || id_grado.length === 0) {
          return;
        }

      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_grado,
      };
      
      try {
        let response = await axios.post(
          "/horario/horarioDocente/seccionesgrados",
          params
        );
        this.SeccionGradoAreas = response.data;       
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    formatSeccionGrado(item) {
      return `${item.nombre_seccion} - ${item.desc_grado}`;
    },

    async cursoDocenteArea(id_grado) {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_grado: id_grado,
        id_area_docente: this.id_area_docente,
      };

      try {

        let response = await axios.post(
          "/horario/horarioDocente/areas/cursos/",
          params
        );

        if (Array.isArray(response.data)) {
          // Mapea los cursos y áreas administrativas de la respuesta
          this.cursoDocente = response.data.map((curso) => {
            return {
              id_curso: curso.id, // Este será usado como el valor del select
              curso: `${curso.desc_curso} - ${curso.grado}`, // Texto que se mostrará
              id_area_admin: curso.id_area_admin,
            };
      });

      this.curso = this.cursoDocente.map(curso => curso.id_curso);
      this.id_area_admin = this.cursoDocente.map(curso => curso.id_area_admin);
      
    }
  } catch (error) {
    this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
  }
},

    formatDocenteArea(item) {
      return `${item.desc_curso} - ${item.grado}`;
    },

    async saveCursos() {
    const existePolidocenteEnGrado = this.horariosDocentes.some(horario => 
      Array.isArray(horario.id_seccion) && horario.id_seccion.includes(this.id_seccion) && horario.id_tipo_docente == 2
    );

    if (existePolidocenteEnGrado) {
      this.setEnviarMens({ tipo: "E", mensaje: "Ya existe un polidocente registrado en este grado.", tiempo: 3000 });
      return;
    }
 
      // datos polidocentes
      const cursosIds = this.cursosSeleccionados.map(curso => {
        if (typeof curso === 'object' && curso !== null) {
          return curso.id_cursos;
        }
        return curso;
      });

      this.cursosSeleccionados.forEach(curso => {
        if (typeof curso === 'object' && curso !== null) {
          if (!this.id_area_polidocente.includes(curso.id)) {
            this.id_area_polidocente.push(curso.id);
          }
        }
      });


      this.id_area_polidocente = this.id_area_polidocente.filter((id, index) => {
        return index < this.cursosSeleccionados.length;
      });


      const areaIds = this.id_area_polidocente;

      // consolidacion
      this.idCursoFinal = cursosIds.length ? cursosIds : (Array.isArray(this.curso) ? this.curso : [this.curso]);

      // Para areaFinal: asegúrate de que no envuelves un array dentro de otro
      this.areaFinal = areaIds.length ? areaIds : (Array.isArray(this.id_area_admin) ? this.id_area_admin : [this.id_area_admin]);

      try {

        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_grado: this.id_grado,
          id_nivel: this.id_nivel,
          id_seccion: this.id_seccion,
          id_curso: this.idCursoFinal,
          area: this.areaFinal,
          id_personales: this.id_personales,
          id_persona: this.id_persona,
          id_tipo_docente: this.id_tipo_docente,
          id_turno: this.id_turno
        };
        // eslint-disable-next-line no-unused-vars
        let response = await axios.post("/horario/horarioDocente/", params);
        this.closeModal();
        this.fetchAndCombineData();
        this.remove();

        this.setEnviarMens({ tipo: "S", mensaje: "Cursos guardados exitosamente.", tiempo: 3000 });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });

      }
    }

  },
};
</script>

<style scoped>
.course {
  background-color: #4db6ac;
  color: white;
  margin: 5px;
  padding: 10px;
  text-align: center;
  border-radius: 4px;
  flex-grow: 1;
}

.v-card-text {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
